export default __webpack_public_path__ + "static/media/free.b6e61fb5.png";